/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import Typography from '@mui/material/Typography'
import * as classes from './styles'

type Item = {
  title: string
  value: string | number
}

type Props = {
  title?: string
  items: Item[]
  className?: string
}

export const tooltipContentClasses = {
  ul: 'tooltip-content-ul',
  li: 'tooltip-content-li',
  itemContentTitle: 'tooltip-content-item-content-title',
  itemContentValue: 'tooltip-content-item-content-value',
}

export const TooltipContent: FC<Props> = ({ title, items, className }) => (
  <div css={classes.wrapper} className={className}>
    {title && <Typography css={classes.title}>{title}</Typography>}

    <ul css={classes.ul} className={tooltipContentClasses.ul}>
      {items.map(({ title, value }, index) => (
        <li key={index} css={classes.li} className={tooltipContentClasses.li}>
          <Typography css={classes.itemContent} className={tooltipContentClasses.itemContentTitle}>
            {title}
          </Typography>
          <Typography css={classes.itemContent} className={tooltipContentClasses.itemContentValue}>
            {value}
          </Typography>
        </li>
      ))}
    </ul>
  </div>
)
